export const GENDER_OPTIONS = [
  "male",
  "female",
  "other",
  "prefer_not_to_say",
] as const;

export type GenderOption = (typeof GENDER_OPTIONS)[number];

/**
 * Normalize API gender (string | object) into a form value.
 */
export const normalizeGender = (
  gender: string | object | undefined | null
): string => {
  if (!gender) return "";
  if (typeof gender === "string") {
    const normalized = gender.toLowerCase().trim();
    return GENDER_OPTIONS.includes(normalized as GenderOption)
      ? normalized
      : gender;
  }

  if (typeof gender === "object") {
    const record = gender as Record<string, unknown>;
    const candidate =
      (typeof record.value === "string" && record.value) ||
      (typeof record.name === "string" && record.name) ||
      (typeof record.code === "string" && record.code) ||
      "";

    if (!candidate) return "";
    const normalized = candidate.toLowerCase().trim();
    return GENDER_OPTIONS.includes(normalized as GenderOption)
      ? normalized
      : candidate;
  }

  return "";
};
